import { SearchResults } from 'algoliasearch-helper';
import type { BaseHit, Hit } from 'instantsearch.js';
import { useState } from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch';

const defaultStableHitsState = {
  params: undefined,
  res: {
    hits: [],
    results: undefined,
    isRefined: false,
    loading: true,
  },
};

interface StableHitsState<T extends BaseHit> {
  params: string | undefined;
  res: {
    hits: Hit<T>[];
    results: SearchResults<Hit<T>> | undefined;
    loading: boolean;
  };
}

export const useStableHits = <T extends BaseHit>() => {
  const [state, setState] = useState<StableHitsState<T>>(
    defaultStableHitsState
  );
  const { items, results } = useHits<T>();
  const { status } = useInstantSearch();

  // eslint-disable-next-line no-underscore-dangle
  const loading = !results || !!results.__isArtificial || status === 'loading';

  // eslint-disable-next-line no-underscore-dangle
  const params = `${String(loading)}-${JSON.stringify(results?._rawResults)}`;

  if (state.params !== params) {
    setState({
      params,
      res: {
        hits: items,
        results,
        loading,
      },
    });
  }

  return state.res;
};
